/* LitLane — product page behaviour: gallery, size picker, bundle picker, add to cart, timer, sticky bar. */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace('{{amount}}', parts.join('.'));
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-pv-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pv-thumb]'));
    if (!main || !thumbs.length) return;
    var i = 0;
    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      main.src = t.dataset.src;
      main.alt = t.dataset.alt || '';
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-pv-prev]');
    var next = root.querySelector('[data-pv-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      startX = null;
    });
  }

  /* ---------- Buy box: tiers x per-panel size picks ---------- */
  function initBuyBox(root) {
    var fmt = root.dataset.moneyFormat || '${{amount}}';
    var currency = root.dataset.currency || '';
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-pv-option]'));
    var button = root.querySelector('[data-pv-atc]');
    var buttonText = button ? button.querySelector('[data-pv-atc-text]') : null;
    var errorEl = root.querySelector('[data-pv-error]');
    var priceNow = root.querySelector('[data-pv-price-now]');
    var priceWas = root.querySelector('[data-pv-price-was]');
    var priceSave = root.querySelector('[data-pv-price-save]');
    var protectVariant = root.dataset.protectVariant || '';
    var protectPrice = parseInt(root.dataset.protectPrice || '0', 10);
    var protectBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-pv-protect]'));
    var variants = {};
    try {
      var raw = root.querySelector('[data-pv-variants]');
      (raw ? JSON.parse(raw.textContent) : []).forEach(function (v) { variants[String(v.id)] = v; });
    } catch (e) {}
    var state = { protect: false, total: 0 };

    function selected() { return tiers.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0]; }
    function picks(tier) { return Array.prototype.slice.call(tier.querySelectorAll('[data-pv-pick]')); }

    function totals(tier) {
      var units = parseInt(tier.dataset.units || '1', 10);
      var pct = parseFloat(tier.dataset.discount || '0');
      var sum = 0;
      picks(tier).forEach(function (sel) { var v = variants[sel.value]; sum += v ? parseInt(v.price, 10) : 0; });
      var total = Math.round(sum * (100 - pct) / 100);
      return { units: units, pct: pct, sum: sum, total: total, each: Math.round(total / units) };
    }

    function render() {
      tiers.forEach(function (tier) {
        var t = totals(tier);
        var pEl = tier.querySelector('[data-pv-tier-price]');
        var wEl = tier.querySelector('[data-pv-tier-was]');
        var eEl = tier.querySelector('[data-pv-tier-each]');
        var pill = tier.querySelector('[data-pv-tier-pill]');
        if (pEl) pEl.textContent = money(t.total, fmt);
        if (wEl) { wEl.textContent = money(t.sum, fmt); wEl.hidden = !(t.pct > 0); }
        if (eEl) eEl.textContent = money(t.each, fmt);
        if (pill) { pill.textContent = (root.dataset.saveLabel || 'Save') + ' ' + Math.round(t.pct) + '%'; pill.hidden = !(t.pct > 0); }
      });
      var o = selected();
      if (!o) return;
      var t = totals(o);
      state.total = t.total;
      var grand = t.total + (state.protect && protectVariant ? protectPrice : 0);
      if (buttonText) buttonText.textContent = money(grand, fmt) + (currency ? ' ' + currency : '') + ' · ' + (root.dataset.atcLabel || 'ADD TO CART');
      if (priceNow) priceNow.textContent = money(t.total, fmt);
      if (priceWas) { priceWas.textContent = money(t.sum, fmt); priceWas.hidden = !(t.pct > 0); }
      if (priceSave) { priceSave.textContent = (root.dataset.saveLabel || 'Save') + ' ' + money(t.sum - t.total, fmt); priceSave.hidden = !(t.pct > 0); }
      var sticky = document.querySelector('[data-pv-sticky-price]');
      if (sticky) sticky.textContent = money(t.total, fmt);
      var first = picks(o)[0];
      if (first && window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', window.location.pathname + '?variant=' + first.value); } catch (e) {}
      }
    }

    tiers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (e.target.closest('select') || e.target.closest('button') || e.target.closest('input') || e.target.closest('.pv-protect')) return;
        if (o.getAttribute('aria-checked') === 'true') return;
        tiers.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        o.setAttribute('aria-checked', 'true');
        render();
      });
      o.addEventListener('keydown', function (e) {
        if ((e.key === ' ' || e.key === 'Enter') && e.target === o) { e.preventDefault(); o.click(); }
      });
      picks(o).forEach(function (sel) { sel.addEventListener('change', render); });
    });

    protectBoxes.forEach(function (box) {
      box.addEventListener('change', function () {
        state.protect = box.checked;
        protectBoxes.forEach(function (b) { b.checked = state.protect; });
        render();
      });
    });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }

    function addToCart() {
      var o = selected();
      if (!o) return;
      if (errorEl) errorEl.classList.remove('is-visible');
      var counts = {};
      picks(o).forEach(function (sel) { counts[sel.value] = (counts[sel.value] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (!items.length) return;
      if (protectVariant && state.protect) items.push({ id: parseInt(protectVariant, 10), quantity: 1 });

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
      }

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showError(res.description || res.message || 'Could not add to cart.'); return; }
          if (drawer && drawer.renderContents && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { showError('Could not add to cart. Please try again.'); })
        .finally(function () {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        });
    }

    if (button) button.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    render();
  }

  /* ---------- Countdown (evergreen, per browser session) ---------- */
  function initTimer(el) {
    var minutes = parseInt(el.dataset.minutes || '10', 10);
    var key = 'pv_timer_end';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (!end || end < now) { end = now + minutes * 60 * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    var clock = el.querySelector('[data-pv-clock]');
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0) { end = Date.now() + minutes * 60 * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} left = end - Date.now(); }
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Sticky bar ---------- */
  function initSticky(bar) {
    var anchor = document.querySelector('#proview-buy');
    if (!anchor) return;
    document.body.classList.add('pv-has-sticky');
    function check() {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------- Buy-now links scroll to the buy box ---------- */
  function initScrollLinks() {
    document.querySelectorAll('a[href="#proview-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector('#proview-buy');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pv-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-pv-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-pv-timer]').forEach(initTimer);
    document.querySelectorAll('[data-pv-sticky]').forEach(initSticky);
    initScrollLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
